import React from "react";
import { Body1, Button, Caption1, Divider, Subtitle1, Subtitle2 } from "@fluentui/react-components";
import { ProfileSelector, TriggeringStylingPane } from "src/components";
import { useErrorContext, useProfileContext } from "src/providers";
import { UnavailableStylesError } from "src/services/errors/style-service-errors";
import "./styles/HomePage.css";

interface HomePageProps {
  onNavigateToReview: () => void;
  onStylingComplete: () => void;
}

export const HomePage: React.FC<HomePageProps> = ({ onNavigateToReview, onStylingComplete }) => {
  const { commitProfile, isRunning } = useProfileContext();
  const {
    clearErrors,
    lastStylingRunFailed,
    setClassificationOutcome,
    setUnavailableStyles,
    setValidationError,
  } = useErrorContext();

  const handleReviewStylesClick = async () => {
    clearErrors();
    try {
      const committedProfileName = await commitProfile();
      if (!committedProfileName) {
        return;
      }
      onNavigateToReview();
    } catch (err) {
      if (err instanceof UnavailableStylesError) {
        setValidationError(err.message);
        setUnavailableStyles(err.unavailableStyles);
      } else {
        setClassificationOutcome("error");
      }
    }
  };

  return (
    <div className="styling-page">
      <div className="select-profile">
        <div className="select-profile-header">
          <Subtitle1>Select Profile</Subtitle1>
          <Body1 className="profile-description">
            Choose the profile most appropriate for this book from the list below.
          </Body1>
        </div>
        <ProfileSelector />
      </div>
      <Divider className="divider"></Divider>
      <div className="styling-page-footer">
        <TriggeringStylingPane onStylingComplete={onStylingComplete} />
        <div className="styling-page-review-styles">
          <Divider className="styling-page-divider">
            <Caption1>or</Caption1>
          </Divider>
          <Button
            appearance="secondary"
            size="large"
            onClick={handleReviewStylesClick}
            disabled={isRunning || lastStylingRunFailed}
          >
            <Subtitle2>Review Styles</Subtitle2>
          </Button>
        </div>
      </div>
    </div>
  );
};
